import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import configurationService from 'common/services/configuration-service/configuration.service';
import { Card, Col, Form, Input, Row, Space, Switch } from 'antd';
import { FormWrapper } from 'common/components/form-wrapper/form-wrapper';
import { notification } from 'common/utils/notification';
import configurationStore from 'common/stores/configuration/configuration.store';
import { IMassAlertsConfigurationUpdate } from 'common/services/configuration-service/configuration.service.types';
import TextArea from 'antd/es/input/TextArea';
import styles from './../default/default-configuration.module.scss';

interface IMassAlertConfigurationForm {
  emailTitle: string;
}

const MassAlertConfiguration = observer(() => {
  const [form] = Form.useForm();

  const configuration = configurationStore.configuration;
  const initData = configuration?.massAlerts;

  let timeoutId: any;

  const handleFormValuesChange = (changedValues: any, allValues: any) => {
    clearTimeout(timeoutId);

    timeoutId = setTimeout(() => {
      form.submit();
    }, 1500);
  };

  const onFinish = async (values: IMassAlertConfigurationForm) => {
    const model: IMassAlertsConfigurationUpdate = {
      massAlerts: {
        emailTitle: values.emailTitle,
      },
    };

    const result = await configurationService.updateSystemConfiguration(model);
    configurationStore.setConfiguration(result);
    notification.success({
      message: 'Configurations successfully updated',
      duration: 5,
    });
  };

  useEffect(() => {
    if (form) {
      form.setFieldsValue(initData);
    }
  }, [form, initData]);

  return (
    <FormWrapper form={form} onValuesChange={handleFormValuesChange} onFinish={onFinish} layout="vertical">
      <Card className="eiq-card eiq-card-border eiq-configuration">
        <Row className="eiq-card-header">
          <Col span={24}>
            <h1 className="h1">Mass Alerts Settings</h1>
          </Col>
        </Row>
        <Col xs={24} sm={12}>
          <Space className="full-width drive-id-configuration-wrapper" size={13}>
            <div style={{ display: 'flex', flexDirection: 'column', marginTop: '16px', gap: 8 }}>
              <span className={styles.label}>Email Title</span>
              <span className={`${styles.italic} ${styles.description}`}>
                {`You can customize the Management Name displayed in the email header. If you leave this field blank, ${configuration?.default.communityName} Management
                will be displayed by default.`}
              </span>
              <Form.Item
                style={{ marginTop: '10px' }}
                name="emailTitle"
                rules={[{ type: 'string', max: 100, message: 'Maximum length 100 characters' }]}>
                <TextArea maxLength={100} showCount className={styles.eiqTextArea} placeholder="Enter email title" />
              </Form.Item>
            </div>
          </Space>
        </Col>
      </Card>
    </FormWrapper>
  );
});

export default MassAlertConfiguration;
